import {createContext, useContext, useState} from 'react'

import {noop} from '@sdox/utils'

import {Overlay} from '../components/Overlay'

import type {PropsWithChildren} from 'react'

interface OverlayContextProps {
  visible: boolean
  setVisibility(visible: boolean): void
}

const OverlayContext = createContext<OverlayContextProps>({visible: false, setVisibility: noop})

export const useOverlay = () => useContext(OverlayContext)

export const OverlayProvider = ({children}: PropsWithChildren) => {
  const [visible, setVisibility] = useState<boolean>(false)

  return (
    <OverlayContext.Provider value={{visible, setVisibility}}>
      {children}
      <Overlay
        visible={visible}
        onClose={() => setVisibility(false)}
      />
    </OverlayContext.Provider>
  )
}
